import { useState } from 'react';
import { InternalTab } from '..';
import { Tabs, TabsContent } from '../../components/Tabs';
import { LifeglovsTab } from './LifeglovsTab';
import { SessionsTab } from './SessionsTab';
import { SurveysTab } from './SurveysTab';
import { UtilizationTab } from './UtilizationTab';

function defaultSessionsDateRange(): [Date, Date] {
  // Past three months (inclusive of the current month)
  const start = new Date();
  start.setDate(1);
  start.setMonth(start.getMonth() - 2);
  return [start, new Date()];
}

export function InternalDashboard() {
  const [utilizationDateRange, setUtilizationDateRange] = useState<[Date, Date] | null>(null);
  const [sessionsDateRange, setSessionsDateRange] = useState<[Date, Date] | null>(defaultSessionsDateRange);

  return (
    <Tabs defaultValue={InternalTab.Utilization} className="flex-1 flex-col">
      <TabsContent value={InternalTab.Utilization}>
        <UtilizationTab dateRange={utilizationDateRange} onDateRangeChange={setUtilizationDateRange} />
      </TabsContent>

      <TabsContent value={InternalTab.Sessions}>
        <SessionsTab dateRange={sessionsDateRange} onDateRangeChange={setSessionsDateRange} />
      </TabsContent>

      <TabsContent value={InternalTab.Lifeglovs}>
        <LifeglovsTab />
      </TabsContent>

      <TabsContent value={InternalTab.Surveys}>
        <SurveysTab />
      </TabsContent>
    </Tabs>
  );
}
